// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"2ddb6c7b","238":"b9ba63e0","453":"009db501","454":"2a6bc2a7","567":"54f4507a","713":"614a4377","775":"5038e0c2","843":"f961f58c","904":"91d36071"}[chunkId] + ".chunk.js";
};